export default {
  data: () => ({
    translations: {
      cardHeader: {
        el: 'Πρόσθετες πληροφορίες καμπάνιας',
        en: 'Campaign Additional Info',
        it: 'Informazioni aggiuntive sulla campagna',
      },
      campaignInfo_general: {
        el: 'Πληροφορίες καμπάνιας',
        en: 'Campaign Information',
        it: 'Informazioni sulla campagna',
      },
      campaignInfo_coupons: {
        el: 'Πληροφορίες Επιβράβευσης',
        en: 'Reward Information',
        it: 'Informazioni sulla campagna',
      },
      campaignInfo_notifications: {
        el: 'Πληροφορίες Ειδοποιήσεων',
        en: 'Notifications Information',
        it: 'Informazioni sulle notifiche',
      },
      campaignInfo_participants: {
        el: 'Πληροφορίες Συμμετοχών',
        en: 'Participants Information',
        it: 'Informazioni sui partecipanti',
      },
      campaignInfo_statistics: {
        el: 'Πληροφορίες Απόδοσης',
        en: 'Performance Information',
        it: 'Informazioni sulle prestazioni',
      },
      title: {
        el: 'Όνομα',
        en: 'Title',
        it: 'Nome',
      },
      campaignId: {
        el: 'ID Καμπάνιας',
        en: 'Campaign ID',
        it: 'ID Campagna',
      },
      startDate: {
        el: 'Έναρξη',
        en: 'Start Date',
        it: 'Lancia',
      },
      endDate: {
        el: 'Λήξη',
        en: 'End Date',
        it: 'Fine',
      },
      status: {
        el: 'Κατάσταση',
        en: 'Status',
        it: 'Stato',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      email: {
        el: 'Email',
        en: 'Email',
        it: 'Email',
      },
      push: {
        el: 'Push',
        en: 'Push',
        it: 'Push',
      },
      sms: {
        el: 'Sms',
        en: 'Sms',
        it: 'Sms',
      },
      viber: {
        el: 'Viber',
        en: 'Viber',
        it: 'Viber',
      },
      totalParticipants: {
        el: 'Σύνολο Συμμετοχών',
        en: 'Total Participants',
        it: 'Partecipanti totali',
      },
      total: {
        el: 'Σύνολο',
        en: 'Total',
        it: 'Totali',
      },
      notified: {
        el: 'Ειδοποιήθηκαν με',
        en: 'Notified by',
        it: 'Notificato dq',
      },
      createNewCampaign: {
        el: 'Δημιουργία νέας καμπάνιας',
        en: 'Create New Campaign',
        it: 'Crea nuova campagna',
      },
      createNewDraw: {
        el: 'Δημιουργία κλήρωσης',
        en: 'Create Draw',
        it: 'Crea disegno',
      },
      newDrawDialogTitle: {
        el: 'Δημιουργία κλήρωσης από καμπάνια',
        en: 'Create Draw From Campaign',
        it: 'Creare un disegno dalla campagna ',
      },
      chooseDates: {
        el: 'Επιλέξτε τις ημερομηνίες',
        en: 'Choose the dates',
        it: 'Scegliere le date',
      },
      optional: {
        el: 'Προαιρετικό',
        en: 'Optional',
        it: 'Opzionale',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },

      notifications: {
        el: 'Ειδοποιήσεις',
        en: 'Notifications',
        it: 'Notifiche',
      },

      createdAt: {
        el: 'Ημ/νία δημιουργίας',
        en: 'Creation Date',
        it: 'Data di creazione',
      },

      activatedAt: {
        el: 'Ημ/νία Ενεργοποίησης',
        en: 'Activation Date',
        it: 'Data di attivazione',
      },

      changeStatus: {
        el: 'Αλλαγή κατάστασης',
        en: 'Change Status',
        it: 'Cambiamento di stato',
      },

      transactionInfo: {
        el: 'Πληροφορίες Συναλλαγής',
        en: 'Transaction Information',
        it: 'Informazioni sulla transazione',
      },

      transactionId: {
        el: 'ID Συναλλαγής',
        en: 'Transaction ID',
        it: 'ID Transazione',
      },

      participantId: {
        el: 'ID Συμμετέχοντος',
        en: 'Participant ID',
        it: 'ID Partecipante',
      },

      mobile: {
        el: 'Κινητό',
        en: 'Mobile',
        it: 'Mobile',
      },

      participations: {
        el: 'Συμμετοχές',
        en: 'Participations',
        it: 'Partecipazioni',
      },

      completed: {
        el: 'Oλοκληρώθηκε',
        en: 'Completed',
        it: 'Completato',
      },

      campaign_participant_id: {
        el: 'ID Συμμετέχοντα',
        en: 'Campaign Participant ID',
        it: 'ID partecipante alla campagna',
      },

      user_account_id: {
        el: 'ID λογαριασμού χρήστη',
        en: 'User Account Id',
        it: 'ID account utente',
      },

      user_id: {
        el: 'ID χρήστη',
        en: 'User ID',
        it: 'Id utente',
      },

      transaction_id: {
        el: 'ID συναλλαγής',
        en: 'Transaction ID',
        it: 'ID Transazione',
      },

      locked: {
        el: 'Kλειδωμένο',
        en: 'Locked',
        it: 'Bloccato',
      },

      not_rewarded: {
        el: 'Δεν ανταμείφθηκε',
        en: 'Not Rewarded',
        it: 'Non ricompensato',
      },

      hasReward: {
        el: 'Με επιβράβευση',
        en: 'With Reward',
        it: 'Con ricompensa',
      },

      hasBirthday: {
        el: 'Έχει γενέθλια',
        en: 'Has Birthday',
        it: 'Ha un compleanno',
      },

      total_points: {
        el: 'Συνολικοί πόντοι',
        en: 'Total Points',
        it: 'Punti totali',
      },
      estimatedCost: {
        el: 'Μέγιστο εκτιμώμενο κόστος',
        en: 'Maximum Estimated Cost',
        it: 'Costo stimato massimo',
      },
      total_cashback: {
        el: 'Συνολικό Cashback',
        en: 'Total Cashback',
        it: 'Cashback totale',
      },

      total_price: {
        el: 'Συνολική τιμή',
        en: 'Total Price',
        it: 'Prezzo totale',
      },

      transaction_items: {
        el: 'Στοιχεία συναλλαγής',
        en: 'Transaction Items',
        it: 'Voci di transazione',
      },

      price: {
        el: 'Tιμή',
        en: 'Price',
        it: 'totale',
      },

      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },

      quantity: {
        el: 'Ποσότητα',
        en: 'Quantity',
        it: 'Quantità',
      },

      total_litres: {
        el: 'Συνολικά λίτρα',
        en: 'Total Litres',
        it: 'Litri totali',
      },

      reward_points_shared: {
        el: 'Διαμοιρασμός Πόντων Επιβράβευσης',
        en: 'Reward Points Shared',
        it: 'Punti premio condivisi',
      },
      reward_cashback_shared: {
        el: 'Διαμοιρασμός Cashback',
        en: 'Reward Cashback Shared',
        it: 'Cashback premio condiviso',
      },
      additionalInfo: {
        el: 'Πρόσθετες Πληροφορίες',
        en: 'Additional Information',
        it: 'Informazioni aggiuntive',
      },
      participantDetails: {
        el: 'Λεπτομέρειες Συμμετέχοντα',
        en: 'Participant Details',
        it: 'Dettagli del partecipante',
      },
      customerDetails: {
        el: 'Λεπτομέρειες πελάτη',
        en: 'Customer Details',
        it: 'Dettagli cliente',
      },

      notification_title: {
        el: 'Τίτλος',
        en: 'Title',
        it: 'Titolo',
      },

      notification_body: {
        el: 'Περιεχόμενο',
        en: 'Content',
        it: 'Contenuto',
      },

      notification_identifier: {
        el: 'Αναγνωριστικό',
        en: 'Identifier',
        it: 'Identificatore',
      },

      coupon_claim_id: {
        el: 'Αναγνωριστικό αίτησης κουπονιού',
        en: 'Coupon Claim ID',
        it: 'ID richiesta coupon',
      },

      couponInfo: {
        el: 'Πληροφορίες κουπονιού',
        en: 'Coupon Information',
        it: 'Informazioni sui coupon',
      },

      expiration_date: {
        el: 'Ημερομηνία λήξης',
        en: 'Expiration Date',
        it: 'Data di scadenza',
      },

      is_used: {
        el: 'Χρησιμοποιήθηκε',
        en: 'Is used',
        it: 'Viene utilizzato',
      },

      voucher: {
        el: 'Κωδικός κουπονιού',
        en: 'Voucher Code',
        it: 'Codice buono',
      },
      campaignType: {
        el: 'Τύπος Καμπάνιας',
        en: 'Campaign Type',
        it: 'Tipo di Campagna',
      },
      transactionTypes: {
        el: 'Επιλεγμένοι τύποι συναλλαγής',
        en: 'Selected Transaction Types',
        it: 'Tipi di transazione selezionati',
      },

      informative: {
        el: 'Ενημερωτική',
        en: 'Informative',
        it: 'Informativo',
      },
      userAction: {
        el: 'Ενέργεια χρήστη',
        en: 'User Action',
        it: "Azione dell'utente",
      },
      action: {
        el: 'Ενέργεια χρήστη',
        en: 'User Action',
        it: "Azione dell'utente",
      },
      one_time_execution: {
        el: 'Εκτέλεση μίας φοράς',
        en: 'One time execution',
        it: 'Esecuzione una tantum',
      },
      on_activate_execution: {
        el: 'Εκτέλεση κατά την ενεργοποίηση',
        en: 'On Activate Execution',
        it: "Esecuzione all'attivazione",
      },
      repeat_execution: {
        el: 'Επαναλαμβανόμενη εκτέλεση',
        en: 'Repeat execution',
        it: "Ripetere l'esecuzione",
      },
      multiple_times_execution: {
        el: 'Πολλαπλή εκτέλεση',
        en: 'Multiple times execution',
        it: 'Esecuzione multipla',
      },
      new_transaction: {
        el: 'Ενέργεια νέας συναλλαγής',
        en: 'New transaction action',
        it: 'Nuova azione di transazione',
      },
      transaction_with_specific_products: {
        el: 'Συναλλαγή με συγκεκριμένα προϊόντα',
        en: 'Transaction with specific products',
        it: 'Transazione con prodotti specifici',
      },
      transaction_goal: {
        el: 'Στόχοι Συναλλαγών',
        en: 'Transactions goal action',
        it: 'Obiettivi della transazione',
      },
      draw: {
        el: 'Κλήρωση',
        en: 'Draw',
        it: 'Disegno',
      },
      products: {
        el: 'Προϊόντα',
        en: 'Products',
        it: 'Prodotti',
      },
      monday: {
        el: 'Δευτέρα ',
        en: 'Monday',
        it: 'Lunedì',
      },
      tuesday: {
        el: 'Τρίτη',
        en: 'Tuesday',
        it: 'Martedì',
      },
      wednesday: {
        el: 'Τετάρτη',
        en: 'Wednesday',
        it: 'Mercoledì',
      },
      thursday: {
        el: 'Πέμπτη',
        en: 'Thursday',
        it: 'Giovedì',
      },
      friday: {
        el: 'Παρασκευή',
        en: 'Friday',
        it: 'Venerdì',
      },
      saturday: {
        el: 'Σάββατο',
        en: 'Saturday',
        it: 'Sabato',
      },
      sunday: {
        el: 'Κυριακή',
        en: 'Sunday',
        it: 'Domenica',
      },
      customerCharacteristics: {
        el: 'Φίλτρα Συμμετεχόντων',
        en: "Participant's Filters",
        it: 'Filtri Partecipanti',
      },
      campaignConditions: {
        el: 'Όροι Καμπάνιας',
        en: 'Campaign Conditions',
        it: 'Condizioni della campagna',
      },
      all_clientsCondition: {
        el: 'Όλοι οι πελάτες',
        en: 'All clients',
        it: 'Tutti i clienti',
      },
      based_on_locationCondition: {
        el: 'Πελάτες βάσει τοποθεσίας',
        en: 'Clients based on location',
        it: 'Clienti in base alla posizione',
      },
      at_least_transactions_certain_storesCondition: {
        el: 'Πελάτες που έχουν κάνει τουλάχιστον Χ συναλλαγές ελάχιστου ποσού Υ',
        en: 'Clients that have done at least X transactions of minimum Y amount',
        it: 'Clienti che hanno effettuato almeno X transazioni di importo minimo Y',
      },
      first_transactions_certain_storesCondition: {
        el: 'Πελάτες που έχουν πραγματοποιήσει τις πρώτες τους Χ συναλλαγές σε συγκεκριμένα καταστήματα',
        en: 'Clients that have done their first X transactions at certain stores',
        it: 'Clienti che hanno effettuato le loro prime X transazioni in determinati negozi',
      },
      first_transaction_certain_storeCondition: {
        el: 'Πελάτες που έχουν πραγματοποιήσει την πρώτη τους συναλλαγή σε συγκεκριμένο κατάστημα',
        en: 'Clients that have done their first transaction at a certain store',
        it: 'Clienti che hanno effettuato la prima transazione presso un determinato negozio',
      },
      acquired_certain_products_certain_storesCondition: {
        el: 'Πελάτες που έχουν αποκτήσει συγκεκριμένα προϊόντα (προϊόντα ομπρέλα) από συγκεκριμένα καταστήματα',
        en: 'Clients that have acquired certain products (umbrella products) from certain shops',
        it: 'Clienti che hanno acquistato determinati prodotti (prodotti ombrello) da determinati negozi',
      },
      from_older_campaignCondition: {
        el: 'Πελάτες που έχουν λάβει παλαιότερη καμπάνια',
        en: 'Clients that have received older campaign',
        it: 'Clienti che hanno ricevuto una campagna più vecchia',
      },
      redeemed_coupon_certain_storesCondition: {
        el: 'Πελάτες που εξαργύρωσαν συγκεκριμένα κουπόνια από συγκεκριμένα καταστήματα',
        en: 'Clients that redeemed certain coupons from certain shops',
        it: 'Clienti che hanno riscattato determinati coupon da determinati negozi',
      },
      from_csvCondition: {
        el: 'Πελάτες από αρχείο CSV με συγκεκριμένη μορφή',
        en: 'Clients from CSV file with certain format',
        it: 'Clienti da file CSV con un determinato formato',
      },
      x_transactions_certain_stores_after_campaignCondition: {
        el: 'Πελάτες που ολοκληρώνουν Χ συναλλαγές μετά τη δημιουργία της καμπάνιας',
        en: 'Customers who complete X transactions after the campaign creation',
        it: 'Clienti che completano X transazioni dopo la creazione della campagna',
      },
      noneCharacteristic: {
        el: 'Δεν απαιτείται επιμέρους προϋπόθεση',
        en: 'No Sub-Condition Needed',
        it: 'Non sono necessarie sottocondizioni',
      },
      genderCharacteristic: {
        el: 'Φύλο',
        en: 'Gender',
        it: 'Genere',
      },
      points_earnedCharacteristic: {
        el: 'Από Χ έως Υ κερδισμένοι πόντοι/cashback',
        en: 'From X to Y points/cashback earned',
        it: 'Da X a Y punti/cashback guadagnati',
      },
      transactions_completedCharacteristic: {
        el: 'Από Χ έως Υ ολοκληρωμένες συναλλαγές',
        en: 'From X to Y transactions completed',
        it: 'Da X a Y transazioni completate',
      },
      currency_purchasedCharacteristic: {
        el: 'Από X έως Y ευρώ αγορών',
        en: 'From X to Y euro purchased',
        it: 'Da X a Y euro acquistati',
      },
      registration_periodCharacteristic: {
        el: 'Έχει εγγραφεί μεταξύ της ημερομηνίας X και της ημερομηνίας Y',
        en: 'Registered between Date X and Date Y',
        it: 'Registrato tra la data X e la data Y',
      },
      last_transactionCharacteristic: {
        el: 'Tελευταία συναλλαγή',
        en: 'Last transaction',
        it: 'Ultima transazione',
      },
      birth_dateCharacteristic: {
        el: 'Ηλικία',
        en: 'Age',
        it: 'Età',
      },
      store_point_titleCharacteristic: {
        el: 'Επίπεδα',
        en: 'Tiers',
        it: 'Livelli',
      },
      selectedStores: {
        el: 'Επιλεγμένα Kαταστήματα',
        en: 'Selected Stores',
        it: 'Negozi selezionati',
      },
      selectedDate: {
        el: 'Επιλεγμένη Hμερομηνία',
        en: 'Selected Date',
        it: 'Data selezionata',
      },
      selectedDates: {
        el: 'Επιλεγμένες Hμερομηνίες',
        en: 'Selected Dates',
        it: 'Date selezionate',
      },
      selectedAges: {
        el: 'Επιλεγμένες Ηλικίες',
        en: 'Selected Ages',
        it: 'Età selezionate',
      },
      selectedTime: {
        el: 'Επιλεγμένη Ώρα',
        en: 'Selected Time',
        it: 'Tempo selezionata',
      },
      more: {
        el: 'Περισσότερα...',
        en: 'More...',
        it: 'Altro...',
      },
      selectedTimes: {
        el: 'Επιλεγμένες Ώρες',
        en: 'Selected Times',
        it: 'Tempi selezionati',
      },
      all: {
        el: 'Όλα',
        en: 'All',
        it: 'Tutti',
      },
      radius: {
        el: 'Ακτίνα σε χλμ.',
        en: 'Radius in km',
        it: 'Raggio in km',
      },
      transactionsAfterCampaignCreation: {
        el: 'Ελάχιστος αριθμός συναλλαγών',
        en: 'Minimum number of transactions',
        it: 'Numero minimo di transazioni',
      },
      category: {
        el: 'Kατηγορία',
        en: 'Category',
        it: 'Categoria',
      },
      minAmountRule: {
        el: 'Το ελάχιστο ποσό θα πρέπει να συμπληρωθεί για τουλάχιστον ένα από τα επιλεγμένα προϊόντα',
        en: 'Minimum amount must be completed for at least one of the selected products',
        it: "L'importo minimo deve essere completato per almeno uno dei prodotti selezionati",
      },
      executeAfterMinutes: {
        el: 'Εκτέλεση καμπάνιας μετά από X λεπτά από τη συναλλαγή',
        en: 'Execute campaign X minutes after the transaction',
        it: 'Esegui campagna dopo X minuti dalla transazione',
      },
      executeAfterGoalMinutes: {
        el: 'Εκτέλεση καμπάνιας μετά από X λεπτά από την ολοκλήρωση στόχου',
        en: 'Execute campaign X minutes after the goal completed',
        it: "Eseguire la campagna X minuti dopo il completamento dell'obiettivo",
      },
      minAmmount: {
        el: 'Ελάχιστο ποσό ανά συναλλαγή',
        en: 'Minimum amount per transaction',
        it: 'Importo minimo per transazione',
      },
      minQuantity: {
        el: 'Ελάχιστη ποσότητα αγορασμένων προϊόντων',
        en: 'Minimum quantity of purchased products',
        it: 'Quantità minima di prodotti acquistati',
      },
      maximumEntriesPerParticipant: {
        el: 'Μέγιστός αριθμός συμμετοχών για τον κάθε συμμετέχοντα',
        en: 'Maximum entries per participant',
        it: 'Numero massimo di iscrizioni per ogni partecipante',
      },
      requiredTransactions: {
        el: 'Ελάχιστος αριθμός συναλλαγών',
        en: 'Minimum Number of Transactions',
        it: 'Numero minimo di transazioni',
      },
      from: {
        el: 'Από ',
        en: 'From ',
        it: 'Da ',
      },
      to: {
        el: 'Εώς ',
        en: 'To ',
        it: 'Α',
      },
      days: {
        el: 'Ημέρες ',
        en: 'Days ',
        it: 'Giorni ',
      },
      minAmount: {
        el: 'Ελάχιστο Ποσό',
        en: 'Minimum amount spent',
        it: 'Importo minimo',
      },
      amount: {
        el: 'Ποσό',
        en: 'Amount',
        it: 'Importo',
      },
      couponsSelected: {
        el: 'Επιλεγμένα Κουπόνια',
        en: 'Coupons Selected',
        it: 'Tagliandi selezionati',
      },
      titleCampaign: {
        el: 'Τίτλος Kαμπάνιας',
        en: 'Campaign Title',
        it: 'Titolo della Campagna',
      },
      openMap: {
        el: 'Ανοιγμα χαρτη',
        en: 'Open Map',
        it: 'Mappa aperta',
      },
      location: {
        el: 'Τοποθεσία',
        en: 'Location',
        it: 'Posizione',
      },
      gender: {
        el: 'Φύλο',
        en: 'Gender',
        it: 'Sesso',
      },
      transactionsNumber: {
        el: 'Aριθμός Συναλλαγών',
        en: 'Number of Transactions',
        it: 'Numero di transazioni',
      },

      multi_points: {
        el: 'Πολλαπλασιαστής Πόντων',
        en: 'Point Multiplier',
        it: 'Moltiplicatore Di Punti',
      },
      multi_cashback: {
        el: 'Πολλαπλασιαστής Cashback',
        en: 'Cashback Multiplier',
        it: 'Moltiplicatore Di Cashback',
      },
      rewardType: {
        el: 'Τύπος επιβράβευσης',
        en: 'Reward Type',
        it: 'Tipo di ricompensa',
      },
      coupon: {
        el: 'Κουπόνι',
        en: 'Coupon',
        it: 'Coupon',
      },
      reward_points: {
        el: 'Πόντοι επιβράβευσης',
        en: 'Reward Points',
        it: 'Punti premio',
      },
      reward_cashback: {
        el: 'Cashback',
        en: 'Reward Cashback',
        it: 'Cashback premio',
      },
      multiPointsValue: {
        el: 'Τιμή Πολλαπλασιαστή',
        en: 'Multiplier Value',
        it: 'Valore del moltiplicatore',
      },
      invoicingSettings: {
        el: 'Επιλογές Τιμολόγησης',
        en: 'Invoicing Settings',
        it: 'Impostazioni di fatturazione',
      },
      company: {
        el: 'Εταιρεία',
        en: 'Company',
        it: 'Azienda',
      },
      store: {
        el: 'Κατάστημα',
        en: 'Store',
        it: 'Negozio',
      },
      charge: {
        el: 'Χρέωση',
        en: 'Charge to',
        it: 'Carica',
      },
      notificationChannels: {
        el: 'Κανάλια Ειδοποιήσεων',
        en: 'Notification Channels',
        it: 'Canali di Νotifica',
      },
      notificationTypeTitle: {
        el: 'Τύπος Ειδοποιήσεων',
        en: 'Notification Type',
        it: 'Tipo di Νotifica',
      },
      allChannelSendTitle: {
        el: 'Mεσω ολων των καναλιων',
        en: 'Via all channels',
        it: 'Invia tramite tutti i canali',
      },
      prioritySendTitle: {
        el: 'Mε προτεραιοτητα',
        en: 'With priority',
        it: 'Spedizione prioritaria',
      },
      overrideText: {
        el: 'Παράκαμψη των ρυθμίσεων ειδοποίησης χρήστη',
        en: 'Override user notification settings',
        it: "Annullamento delle impostazioni di notifica dell'utente",
      },
      message: {
        el: 'Περιεχόμενο',
        en: 'Message',
        it: 'Contenuto',
      },
      count_per_sms: {
        el: 'Αριθμός SMS περιεχομένου',
        en: 'Number of content SMS ',
        it: 'Numero di SMS contenuti',
      },

      DELIVERED: {
        el: 'Παραδοτέα',
        en: 'Delivered',
        it: 'Consegnati',
      },
      FAILED: {
        el: 'Αποτυχημένα',
        en: 'Failed',
        it: 'Falliti',
      },
      SENT: {
        el: 'Απεσταλμένα',
        en: 'Sent',
        it: 'Inviati',
      },
      image: {
        el: 'Εικόνα',
        en: 'Image',
        it: 'Immagine',
      },
      link: {
        el: 'Σύνδεσμος',
        en: 'Link',
        it: 'Link',
      },

      fallbackSms: {
        el: 'Εφεδρικό SMS',
        en: 'Fallback SMS ',
        it: 'SMS di Backup ',
      },
      button: {
        el: 'Κουμπί',
        en: 'Button',
        it: 'Pulsante',
      },
      button_url: {
        el: 'URL κουμπιού',
        en: 'Button URL',
        it: 'URL del pulsante',
      },

      channelData: {
        el: 'Στοιχεία  Kαναλιών',
        en: 'Channel Data',
        it: 'Dati del canale',
      },

      activatedCampaignTitle: {
        el: 'Ενεργοποίηση Kαμπάνιας',
        en: 'Activate Campaign',
        it: 'Attivare la Campagna',
      },
      activatedCampaignText: {
        el: 'Σίγουρα θέλετε να ενεργοποιήσετε τη συγκεκριμένη καμπάνια;',
        en: 'Are you sure you want to activate this particular campaign?',
        it: 'È sicuro di voler attivare questa particolare campagna?',
      },
      canceledCampaignTitle: {
        el: 'Ακύρωση Kαμπάνιας',
        en: 'Cancel Campaign',
        it: 'Annullamento della Campagna',
      },
      canceledCampaignText: {
        el: 'Σίγουρα θέλετε να ακυρώσετε τη συγκεκριμένη καμπάνια;',
        en: 'Are you sure you want to cancel this particular campaign?',
        it: 'È sicuro di voler cancellare questa particolare campagna?',
      },
      runningCampaignTitle: {
        el: 'Τρέξιμο Kαμπάνιας',
        en: 'Run Campaign',
        it: 'Correre la Campagna',
      },
      runningCampaignText: {
        el: 'Σίγουρα θέλετε να τρέξετε τη συγκεκριμένη καμπάνια;',
        en: 'Are you sure you want to run this particular campaign?',
        it: 'È sicuro di voler correre questa particolare campagna?',
      },
      uniqueParticipants: {
        el: 'Οι χρήστες στο αρχείο είναι μοναδικοί και ο καθένας θα πρέπει να συμπεριληφθεί μία φορά στους συμμετέχοντες.',
        en: 'Users in file are unique and each one should be included once into participants.',
        it: 'Gli utenti del file sono unici e ciascuno di essi deve essere incluso una sola volta nei partecipanti.',
      },
      validityPeriod: {
        el: 'Περίοδος εγκυρότητας (σε δευτερόλεπτα)',
        en: 'Validity Period (in seconds)',
        it: 'Periodo di validità (in secondi)',
      },
      promotional: {
        el: 'Στο μήνυμα υπάρχει εικόνα και κουμπί συνδέσμου (προωθητικό)',
        en: 'There is an image and a link button in the message (promotional)',
        it: "Nel messaggio saranno presenti un'immagine e un pulsante di collegamento (promozionale)",
      },
      date: {
        el: 'Ημερομηνία',
        en: 'Date ',
        it: 'Data ',
      },
      showRewarded: {
        el: 'Εμφάνιση μόνο των βραβευμένων συμμετεχόντων',
        en: 'Show only the rewarded participants',
        it: 'Mostra solo i partecipanti premiati',
      },
      refreshReward: {
        el: 'Ανανέωση Επιβράβευσης',
        en: 'Refresh Reward ',
        it: 'Premio di aggiornamento ',
      },

      refreshRewardSuccess: {
        el: 'Αλλάξατε με επιτυχία τον επιβραβευμένο συμμετέχοντα!',
        en: 'You have successfully changed rewarded participant!',
        it: 'Avete cambiato con successo il partecipante premiato!',
      },
      reward: {
        el: 'Επιβράβευση',
        en: 'Reward ',
        it: 'Premio',
      },
      uptoAge: {
        el: '',
        en: 'Up ',
        it: 'fino',
      },
      minimum_transactions: {
        el: 'Ελάχιστος αριθμός συναλλαγών',
        en: 'Minimum number of transactions',
        it: 'Numero minimo di transazioni',
      },
      goalType: {
        el: 'Τύπος στόχου',
        en: 'Goal Type',
        it: 'Tipo di obiettivo',
      },
      goalCounter: {
        el: 'Μετρητής  στόχου',
        en: 'Goal Counter',
        it: 'Contatore di obiettivo',
      },
      atLeast_points: {
        el: 'Ελάχιστοι πόντοι ανά συναλλαγή',
        en: 'Minimum points per transaction',
        it: 'Quantità minima di punti vincenti',
      },
      atLeast_cashback: {
        el: 'Ελάχιστο cashback ανά συναλλαγή',
        en: 'Minimum cashback per transaction',
        it: 'Cashback minimo per transazione',
      },
      edit: {
        el: 'Επεξεργασία',
        en: 'Edit',
        it: 'Modifica',
      },
      channelTitleModal: {
        el: 'Τίτλος',
        en: 'Title',
        it: 'Titolo',
      },
      channelBodyModal: {
        el: 'Περιεχόμενο',
        en: 'Content',
        it: 'Contenuto',
      },
      smsRewardContent: {
        el: 'Περιεχόμενο sms',
        en: 'Sms content',
        it: 'Contenuto degli sms',
      },
      save: {
        el: 'Αποθήκευση',
        en: 'Save',
        it: 'Salva',
      },
      changeTypeOptions: {
        el: 'Αλλαγή επιλογών τύπου καμπάνιας',
        en: 'Change campaign type options',
        it: 'Modifica delle opzioni del tipo di campagna',
      },
      points_reachedCharacteristic: {
        el: 'Πόντοι που επιτεύχθηκαν',
        en: 'Points reached',
        it: 'Punti raggiunti',
      },
      cashback_reachedCharacteristic: {
        el: 'Cashback που επιτεύχθηκε',
        en: 'Cashback reached',
        it: 'Cashback raggiunto',
      },
      selectedLoyalties: {
        el: 'Επιλεγμένα Προγράμματα Πιστότητας',
        en: 'Selected Loyalty Programs',
        it: 'Programmi di fidelizzazione selezionati',
      },

      selectNotificationChannel: {
        el: 'Επιλέξτε Κανάλια Ειδοποιήσεων',
        en: 'Select Notification Channels',
        it: 'Seleziona canali di notifica',
      },

      selectFrequency: {
        el: 'Επιλέξτε Συχνότητα',
        en: 'Select Frequency',
        it: 'Seleziona Frequenza',
      },
      transactionSettings: {
        el: 'Ρυθμίσεις συναλλαγών',
        en: 'Transaction Settings',
        it: 'Impostazioni di transazione',
      },
      daily: {
        el: 'Kαθημερινα',
        en: 'Daily',
        it: 'Quotidiano',
      },
      weekly: {
        el: 'Εβδομαδιαια',
        en: 'Weekly',
        it: 'Settimanalmente',
      },
      monthly: {
        el: 'Μηνιαια',
        en: 'Monthly',
        it: 'Mensilmente',
      },

      settingsUpdated: {
        el: 'Οι ρυθμίσεις καμπάνιας ενημερώθηκαν με επιτυχία',
        en: 'The campaign settings have been updated successfully',
        it: 'Le impostazioni della campagna sono già state aggiornate',
      },

      checkValues: {
        el: 'Παρουσιάστηκε σφάλμα. Ελέγξτε τα πεδία και δοκιμάστε ξανά.',
        en: 'There was an error. Please, check the values and try again.',
        it: 'Si è verificato un errore. Controlla i valori e riprova.',
      },

      user_account_attributesCharacteristic: {
        el: 'Ιδιότητες λογαριασμού χρήστη',
        en: 'User account attributes',
        it: "Attributi dell'account utente",
      },

      selectedAttributes: {
        el: 'Επιλεγμένες Ιδιότητες',
        en: 'Selected Attributes',
        it: 'Attributi Selezionati',
      },
      'operator=': {
        el: 'ισούται με',
        en: 'equal to',
        it: 'uguale a',
      },
      'operator!=': {
        el: 'δεν ισούται με',
        en: 'not equal to',
        it: 'non uguale a',
      },
      'operator>': {
        el: 'μεγαλύτερο από',
        en: 'greater than',
        it: 'superiore a',
      },
      'operator<': {
        el: 'μικρότερο από',
        en: 'less than',
        it: 'inferiore a',
      },
      'operator>=': {
        el: 'μεγαλύτερο από',
        en: 'greater or equal to',
        it: 'superiore a',
      },
      'operator<=': {
        el: 'μικρότερο από',
        en: 'less or equal to ',
        it: 'inferiore a',
      },
      'operator<>': {
        el: 'μεταξύ εξαιρουμένων',
        en: 'between excluded',
        it: 'tra esclusi',
      },

      exportUrl: {
        el: 'Σύνδεσμος αρχείου',
        en: 'Export URL',
        it: 'URL di esportazione',
      },
      male: {
        el: 'Αρσενικό',
        en: 'Male',
        it: 'Maschio',
      },
      female: {
        el: 'Θηλυκό',
        en: 'Female',
        it: 'Femminile',
      },
      other: {
        el: 'Άλλο',
        en: 'Other',
        it: 'Altro',
      },
      billableText: {
        el: 'Χρέωση ειδοποιήσεων',
        en: 'Billable notifications',
        it: 'Notifiche a pagamento',
      },
      cancelBilling: {
        el: 'Ακύρωση Χρέωσης',
        en: 'Cancel Billing',
        it: 'Annulla fattura',
      },
      confirmBilling: {
        el: 'Eπιβεβαίωση χρέωσης',
        en: 'Confirm billing',
        it: 'conferma addebito',
      },
      confirmationMessageSure: {
        el: 'Σίγουρα θέλεις να κάνεις',
        en: 'Are you sure you want to',
        it: 'Siete sicuri di voler',
      },
      questionmark: {
        el: ' ;',
        en: ' ?',
        it: ' ?',
      },
      submit: {
        el: 'Υποβολή',
        en: 'Submit',
        it: 'Invia',
      },
      couponClaimValidDays: {
        el: 'Περίοδος εξαργύρωσης (σε ημέρες)',
        en: 'Redemption period (in days)',
        it: 'Periodo di riscossione (in giorni)',
      },
      paymentDue: {
        el: 'Υπάρχει απλήρωτη συνδρομή',
        en: 'There is an unpaid invoice',
        it: "C'è una fattura non pagata",
      },
      resetRewards: {
        en: 'Reset Rewards',
        el: 'Επαναφορά Δώρων',
        it: 'Reimposta Premi',
      },
      resetRewardsConfirmation: {
        en: 'Are you sure you want to reset all rewards?',
        el: 'Είστε σίγουροι ότι θέλετε να επαναφέρετε όλα τα δώρα;',
        it: 'Sei sicuro di voler reimpostare tutti i premi?',
      },
      resetRewardsSuccess: {
        en: 'Rewards have been reset successfully.',
        el: 'Τα δώρα επαναφέρθηκαν με επιτυχία.',
        it: 'I premi sono stati reimpostati con successo.',
      },
      addRemainingRewards: {
        en: 'Add Remaining Rewards',
        el: 'Προσθήκη Υπολοίπων Δώρων',
        it: 'Aggiungi Premi Rimanenti',
      },
      addRemainingRewardsConfirmation: {
        en: 'Are you sure you want to add remaining rewards to participants?',
        el: 'Είστε σίγουροι ότι θέλετε να προσθέσετε τα υπόλοιπα δώρα στους συμμετέχοντες;',
        it: 'Sei sicuro di voler aggiungere i premi rimanenti ai partecipanti?',
      },
      addRemainingRewardsSuccess: {
        en: 'Remaining rewards have been added successfully.',
        el: 'Τα υπόλοιπα δώρα προστέθηκαν με επιτυχία.',
        it: 'I premi rimanenti sono stati aggiunti con successo.',
      },
      assignReward: {
        en: 'Assign Reward',
        el: 'Ανάθεση Δώρου',
        it: 'Assegna Premio',
      },
      assignRewardSuccess: {
        en: 'Reward has been assigned successfully.',
        el: 'Το δώρο ανατέθηκε με επιτυχία.',
        it: 'Il premio è stato assegnato con successo.',
      },
      selectReward: {
        en: 'Select Reward',
        el: 'Επιλέξτε Δώρο',
        it: 'Seleziona Premio',
      },
      cancel: {
        el: 'Ακύρωση',
        en: 'Cancel',
        it: 'Annulla',
      },
      remaining: {
        en: 'Remaining',
        el: 'Υπόλοιπο',
        it: 'Rimanente',
      },
      first_name: {
        el: 'Όνομα',
        en: 'First Name',
        it: 'Nome',
      },
      last_name: {
        el: 'Επίθετο',
        en: 'Last Name',
        it: 'Cognome',
      },
      removeRewardTooltip: {
        en: 'Remove assigned reward',
        el: 'Κατάργηση ανατεθειμένου δώρου',
        it: 'Rimuovi il premio assegnato',
      },
      detachReward: {
        en: 'Detach Reward',
        el: 'Αφαίρεση Δώρου',
        it: 'Scollega Premio',
      },
      detachRewardConfirmation: {
        en: 'Are you sure you want to remove the assigned reward from this participant?',
        el: 'Είστε σίγουροι ότι θέλετε να καταργήσετε το ανατεθειμένο δώρο από αυτόν τον συμμετέχοντα;',
        it: 'Sei sicuro di voler rimuovere il premio assegnato a questo partecipante?',
      },
      detachRewardSuccess: {
        en: 'Assigned reward has been removed successfully.',
        el: 'Το ανατεθειμένο δώρο καταργήθηκε με επιτυχία.',
        it: 'Il premio assegnato è stato rimosso con successo.',
      },
      editReward: {
        en: 'Edit Reward',
        el: 'Επεξεργασία Δώρου',
        it: 'Modifica Premio',
      },
      rewardUpdatedSuccessfully: {
        en: 'Reward has been updated successfully.',
        el: 'Το δώρο ενημερώθηκε με επιτυχία.',
        it: 'Il premio è stato aggiornato con successo.',
      },
      invalidRewardPoints: {
        en: 'Invalid points: please enter a non-negative integer.',
        el: 'Μη έγκυροι πόντοι: εισάγετε έναν μη αρνητικό ακέραιο.',
        it: 'Punti non validi: inserisci un intero non negativo.',
      },
      invalidCoupon: {
        en: 'Invalid coupon: please select a coupon.',
        el: 'Μη έγκυρο κουπόνι: επιλέξτε ένα κουπόνι.',
        it: 'Coupon non valido: seleziona un coupon.',
      },
      invalidCouponDays: {
        en: 'Invalid coupon validity days: must be a non-negative integer or empty.',
        el: 'Μη έγκυρες ημέρες ισχύος κουπονιού: πρέπει να είναι μη αρνητικός ακέραιος ή κενό.',
        it: 'Giorni di validità coupon non validi: deve essere un intero non negativo o vuoto.',
      },
      invalidMultiplier: {
        en: 'Invalid multiplier: please choose a multiplier value.',
        el: 'Μη έγκυρος πολλαπλασιαστής: επιλέξτε μια τιμή πολλαπλασιαστή.',
        it: 'Moltiplicatore non valido: scegli un valore del moltiplicatore.',
      },
      rewardRequired: {
        en: 'Reward is required for this campaign type.',
        el: 'Απαιτείται επιβράβευση για αυτόν τον τύπο καμπάνιας.',
        it: 'È richiesta una ricompensa per questo tipo di campagna.',
      },
    },
  }),
};
